import React from "react";
import { Switch } from 'react-router-dom';
import { errorLayout } from '../../layouts/ErrorLayout';
import AppRoute from '../AppRoute';
import Loader from '../../helper/loaders';
import DashboardLayout from '../../layouts/DashboardLayout/DashboardLayout';
import { auth } from '../../utils/authentication/auth';

const ManageUsers = Loader(() =>
    import(/* webpackChunkName: "NotFoundPage" */ '../../containers/Admin/ManageUsers')
);
const EditUser = Loader(() =>
    import(/* webpackChunkName: "NotFoundPage" */ '../../containers/Admin/EditUser')
);
const NotFoundPage = Loader(() =>
    import(/* webpackChunkName: "NotFoundPage" */ '../../containers/not-found-page.component')
);

const AdminRoutes = (props) => {
    let { match } = props;
    return (
        <React.Fragment>
            <Switch>

                <AppRoute
                    path={`${match.path}/manage-users`}
                    component={ManageUsers}
                    layout={DashboardLayout}
                    requireAuth={auth}
                    type='private'
                    title='Manage Users'
                />

                 <AppRoute
                    path={`${match.path}/edit-user/:id`}
                    component={EditUser}
                    layout={DashboardLayout}
                    requireAuth={auth}
                    type='private'
                    title='Update User'
                />

                <AppRoute
                    path={`${match.path}/*`}
                    component={NotFoundPage}
                    requireAuth={() => false}
                    layout={errorLayout}
                    type='public'
                />

            </Switch>
        </React.Fragment>
    )
};

export default AdminRoutes;